"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToCurrency = exports.formatCurrency = exports.format = void 0;
/**
 * Return the amount formatted according to decimal places specified
 * @param {number} amount - price amount
 * @param {number} digits - decimal digits to apply
 * @returns
 */
const format = (amount, digits = 2) => {
    if (!amount)
        return 0;
    const fixedAmount = amount % 1 === 0 ? amount : amount.toFixed(digits);
    return fixedAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
exports.format = format;
/**
 * Can accept negative amounts, uses format under the hood
 * @param {number} amount
 * @param {number} digits - 0 by default as at saatva we dont show pennies normally
 * @returns
 */
const formatCurrency = (amount, digits) => {
    const absolutePrice = amount < 0 ? Math.abs(amount) : amount;
    const negationSymbol = amount < 0 ? '- ' : '';
    const formattedAbsolutePrice = format(absolutePrice, digits);
    return `${negationSymbol}$${formattedAbsolutePrice}`;
};
exports.formatCurrency = formatCurrency;
/**
 * Format amount to specified locale and currency using Intl interface from js
 * @param {number} amount
 * @param {string} locale - by default en-us
 * @param {string} localeCurrency - by default USD
 * @returns
 */
const formatToCurrency = (amount, locale = 'en-US', localeCurrency = 'USD') => {
    if (!amount)
        return 0;
    const formatOptions = { style: 'currency', currency: localeCurrency };
    return new Intl.NumberFormat(locale, formatOptions).format(amount);
};
exports.formatToCurrency = formatToCurrency;
//# sourceMappingURL=price-format.js.map